import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { labTestsApi, CreateLabTestDto, UpdateLabTestDto } from '../api/labTests.api';

export const useLabTests = () => {
  return useQuery({
    queryKey: ['lab-tests'],
    queryFn: () => labTestsApi.getAll(),
    staleTime: 5 * 60 * 1000, // 5 minutes - data is fresh for 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes - cache for 10 minutes
  });
};

export const useCreateLabTest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (newLabTest: CreateLabTestDto) => labTestsApi.create(newLabTest),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lab-tests'] });
      queryClient.invalidateQueries({ queryKey: ['prescription-initial-data'] });
    },
  });
};

export const useUpdateLabTest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdateLabTestDto }) => labTestsApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lab-tests'] });
      queryClient.invalidateQueries({ queryKey: ['prescription-initial-data'] });
    },
  });
};

export const useDeleteLabTest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => labTestsApi.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lab-tests'] });
      queryClient.invalidateQueries({ queryKey: ['prescription-initial-data'] });
    },
  });
};

